import api from "../config/api";
import { Page } from "../types/Page";

const API_URL = "/page";

export const getPages = () =>
  api.get(`${API_URL}/`).then((res) => res.data.data);

export const getPageById = (id: number) => api.get(`${API_URL}/?id=${id}`);

export const getPageByPojectId = (projectId: number) =>
  api.get(`${API_URL}/?projectId=${projectId}`);

export const createPage = (data: Page) => api.post(`${API_URL}/`, data);

export const updatePage = (id: number, data: Page) =>
  api.put(`${API_URL}/?id=${id}`, data);

export const deletePage = (id: number) => api.delete(`${API_URL}/?id=${id}`);
